import React from "react";
import { Chat, UserI, messageType } from "../../../typings/interfaces";
import { PageRoute } from "../../../models";
import { useHistory } from "react-router-dom";
import { Checkbox } from "antd";

import styles from "../chatPage.scss";
import { Separator } from "./Separator";
import { formatDate } from "../../../services";
import { useOtherChatParticipantInfo } from "../hooks/useOtherChatParticipantInfo";
import { getDocumentIcon } from "../../../utils/documentIcons";


type Props = {
  chat: Chat;
  user: UserI;
  isSelected?: boolean;
  isMobile: boolean;
  onSelect?: (checked: boolean) => void;
  isLastItem: boolean
}

export const ChatsListItem = ({ chat, user, isSelected, isLastItem, onSelect }: Props) => {
  const lastReadMessageKey = user.userId === chat.senderId ? 'senderLastReadMessageId' : 'recipientLastReadMessageId';
  const lastReadMessageId = chat[lastReadMessageKey];
  const lastMessage = chat.messages && chat.messages.length > 0 ? chat.messages[chat.messages.length - 1] : null;

  const areAllMessagesRead = lastMessage && (lastMessage.senderId === user.userId || lastMessage.messageId === lastReadMessageId);

  const otherChatParticipantInfo = useOtherChatParticipantInfo(chat, user)

  const slicedLastMessageContent = lastMessage && lastMessage.content && lastMessage.content.length > 75 ?
    `${lastMessage.content.slice(0, 75)}...` :
    lastMessage.content

  const history = useHistory();

  const handleChatClick = (e) => {
    e.preventDefault();
    var scrollPosition = window.scrollY;

    // Save scroll position in current history entry so browser back restores it
    history.replace({
      pathname: history.location.pathname,
      search: history.location.search,
      state: { scrollPosition: scrollPosition }
    });

    const params = new URLSearchParams(window.location.search);
    if (params.get("inboxType") === "null") {
      params.delete("inboxType");
    }
    params.set("chatId", chat.chatId);
    history.push({
      pathname: PageRoute.chats,
      search: params.toString(),
      state: { scrollPosition: scrollPosition }
    });
  }

  const renderLastMessageContent = () => {
    if (!lastMessage) return null;

    if (lastMessage.type === messageType.Image) {
      return (
        <React.Fragment>
          {getDocumentIcon({ fileName: 'image.png', size: 16 })}
          Fotografija
        </React.Fragment>
      );
    }

    if (lastMessage.type === messageType.PDF) {
      return (
        <React.Fragment>
          {getDocumentIcon({ fileName: lastMessage.fileName || 'document.pdf', size: 16 })}
          Privitak
        </React.Fragment>
      );
    }

    return slicedLastMessageContent;
  };

  return (
    <React.Fragment>
      <a href="#" className={styles.chatsListItemLink} rel="noopener noreferrer nofollow" onClick={handleChatClick}>
        <div className={styles.chatsListitem}>
          <div onClick={(e) => e.stopPropagation()}>
            <Checkbox
              checked={isSelected}
              onChange={(e) => {
                e.stopPropagation();
                onSelect(e.target.checked);
              }}
            />

          </div>
          <div className={styles.chatsListItemWrapper}>
            <div className={styles.otherChatParticipantName} style={{ fontWeight: areAllMessagesRead ? 400 : 600 }}>
              {!areAllMessagesRead && <div className={styles.redCircle} />}
              {otherChatParticipantInfo.name}
            </div>
            <div className={styles.lastMessage}>
              <span style={{ fontWeight: areAllMessagesRead ? 400 : 600 }}>
                {chat.adTitle}
              </span>
              <span className={styles.lastMessageContent}>
                {renderLastMessageContent()}
              </span>
            </div>
            <div className={styles.timestamp}>
              {lastMessage && formatDate(lastMessage.sentAt)}
            </div>
          </div>
        </div>
      </a>
      {!isLastItem && <Separator />}
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/ChatsList/ChatsListItem.tsx